/**
 * Rounds a number to the second decimal
 *
 * This is mostly thought to be used with currency values that end up as floats
 * and are otherwise displayed as 1.000000
 */
export default function (value) {
	return (Math.round(value * 100) / 100).toFixed(2);
};
